export default __webpack_public_path__ + "static/media/Ethereum2.62d0bfee.svg";